<!-- Divider -->
<div
  class="servicemesh-vertical-navigation-item-wrapper divider"
  [ngClass]="item.classes?.wrapper"
></div>
